module.exports = __webpack_public_path__ + "static/media/icon_arrow_right.51e3e5d8.svg";